import { set } from 'lodash/fp';
import {
  SET_SINGLE_FIELD,
  SET_MULTIPLE_FIELDS,
  SET_SELECTED_VARIANTS,
  SET_BULK_VARIANT_EDIT,
  SET_LOADING,
} from '../actions/supplierInventory';

const initialState = {
  data: null,
  offset: 0,
  count: 0,
  perPage: 20,
  searchText: '',
  selectedVariants: {
    ids: [],
    objectIds: [],
    variantsWithDetails: [],
  },
  bulkEdit: {
    loading: false,
    success: undefined,
  },
  loading: {
    export: false,
  },
};

const supplierInventory = (state = initialState, action) => {
  switch (action.type) {
    case SET_SINGLE_FIELD: {
      const { key, value } = action.payload;

      return {
        ...state,
        [key]: value,
      };
    }
    case SET_MULTIPLE_FIELDS: {
      const { keyValuePairs } = action.payload;

      return {
        ...state,
        ...keyValuePairs,
      };
    }
    case SET_SELECTED_VARIANTS: {
      const { variantIds } = action.payload;
      return {
        ...state,
        selectedVariants: variantIds,
      };
    }

    case SET_BULK_VARIANT_EDIT: {
      const { data } = action.payload;
      return {
        ...state,
        bulkEdit: data,
      };
    }

    case SET_LOADING:
      return set('loading', action.payload, state);

    default:
      return state;
  }
};

export default supplierInventory;
